
import _ from "lodash"
import list from "@/components/ware-view/list"

export default {
  name: "SimilarWare",
  components: {
    list
  },
  props: {
    similarList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      wareList: []
    }
  },
  watch: {
    similarList: {
      handler(newVal) {
        // console.log('similarList=====>', newVal)
        this.wareList = newVal.map(item => ({
          ...item,
          sku: item.skuId,
          wareName: item.name,
          wareImg: item.imgUrlList && item.imgUrlList[0],
          warePrice: item.originalPrice,
          promotionWareVO: {
            unitProPrice: item.promotionPrice,
            marketPrice: item.originalPrice,
            showLinePrice: item.showOriginalPrice,
            promotionInfoList: _.isEmpty(item.promotionList)
              ? []
              : item.promotionList.map(proItem => ({
                  ...proItem,
                  displayInfo: {
                    proTag: proItem.subTypeName
                  }
                }))
          }
        }))
      },
      immediate: true
    }
  },
  methods: {}
}
